import { FC } from 'react';
import ArticlesPageButton from './ArticlesPageButton';
import { Article } from '../../pages/learn/articles/[slug]';
import ArticlePreviewsSmall from './ArticlePreviewsSmall';
import ArticlePreviewsMedium from './ArticlePreviewsMedium';
import ArticlePreviewsLarge from './ArticlePreviewsLarge';

interface Props {
  articles: Array<Article>;
}

const ArticlePreviews: FC<Props> = ({ articles }) => {
  if (articles.length === 0) return null;

  return (
    <>
      <div className='sm:hidden'>
        <ArticlePreviewsSmall articles={articles} />
      </div>
      <div className='hidden sm:block lg:hidden'>
        <ArticlePreviewsMedium articles={articles} />
      </div>
      <div className='hidden lg:block'>
        <ArticlePreviewsLarge articles={articles} />
      </div>
      <div className='lg:hidden'>
        <ArticlesPageButton />
      </div>
    </>
  );
};

export default ArticlePreviews;
